"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/* eslint-disable no-mixed-operators */
var smoothScroll = function smoothScroll(node) {
  var topOrLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var testSupportsSmoothScroll = function testSupportsSmoothScroll() {
    var supports = false;

    try {
      var div = document.createElement('div');
      div.scrollTo({
        top: 0,

        get behavior() {
          supports = true;
          return 'smooth';
        }

      }); // eslint-disable-next-line no-empty
    } catch (err) {}

    return supports;
  };

  var easingOutQuint = function easingOutQuint(x, t, b, c, d) {
    // via https://github.com/tootsuite/mastodon/blob/f59ed3a4fafab776b4eeb92f805dfe1fecc17ee3/app/javascript/mastodon/scroll.js
    var $t = t;
    return c * (($t = $t / d - 1) * $t * $t * $t * $t + 1) + b;
  };

  var hasNativeSmoothScroll = testSupportsSmoothScroll();

  var smoothScrollPolyfill = function smoothScrollPolyfill(nodeParam, key, target) {
    var $node = nodeParam;
    var startTime = Date.now();
    var offset = node[key];
    var gap = target - offset;
    var duration = 1000;
    var interrupt = false;

    var cancel = function cancel() {
      interrupt = true; // eslint-disable-next-line no-use-before-define

      cleanup();
    };

    var cleanup = function cleanup() {
      $node.removeEventListener('wheel', cancel);
      $node.removeEventListener('touchstart', cancel);
    };

    var step = function step() {
      var elapsed = Date.now() - startTime;
      var percentage = elapsed / duration;

      if (interrupt) {
        return;
      }

      if (percentage > 1) {
        cleanup();
        return;
      }

      $node[key] = easingOutQuint(0, elapsed, offset, gap, duration);
      window.requestAnimationFrame(step);
    };

    $node.addEventListener('wheel', cancel, {
      passive: true
    });
    $node.addEventListener('touchstart', cancel, {
      passive: true
    });
    step();
    return cancel;
  };

  if (hasNativeSmoothScroll) {
    var _node$scrollTo;

    return node.scrollTo((_node$scrollTo = {}, (0, _defineProperty2["default"])(_node$scrollTo, horizontal ? 'left' : 'top', topOrLeft), (0, _defineProperty2["default"])(_node$scrollTo, "behavior", 'smooth'), _node$scrollTo));
  }

  return smoothScrollPolyfill(node, horizontal ? 'scrollLeft' : 'scrollTop', topOrLeft);
};

var _default = smoothScroll;
exports["default"] = _default;